<template>
  <div>
    <div :class="'PG' + $route.params.profgroup + ' row'">
      <div class="d-none d-md-block col-md-4 col-lg-3 col-xl-3">
        <app-filters></app-filters>
      </div>
      <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
        <div class="row btnfilterrow margin20bottom">
          <div class="col-12 col-sm-12 d-md-none">
            <button class="btnfilter btn btn-primary btn-sm" v-on:click="toggleFilter" v-if="!loadMobileFilter">
              <font-awesome-icon :icon="['fas', 'sliders-h']" />&nbsp;{{ translation(16763) }}
            </button>
            <button class="btnfilter btn btn-primary btn-sm" v-on:click="toggleFilter" v-if="loadMobileFilter">
              <font-awesome-icon :icon="['fas', 'sliders-h']" />&nbsp;{{ translation(16764) }}
            </button>
            <!-- op mobiel count in de filter -->
            <div class="row margin20" id="filtercount" v-if="loadMobileFilter">
              <div class="col-12">
                <span>{{ totalCount + '&nbsp;' + translation(16817) }}</span
                >&nbsp;<a href="#" @click="lblreset()">{{ translation(3346) }}</a>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row mobilefilter"
          v-if="loadMobileFilter === true && wLG === false && wXL === false && wMD === false"
        >
          <div class="col-12 col-sm-12">
            <app-filters></app-filters>
          </div>
        </div>
        <div
          class="row AgendaTableRow"
          v-if="loadMobileFilter === false || wLG === true || wXL === true || wMD === true"
        >
          <div class="col-12 col-sm-12" v-if="filterLoaded">
            <app-tabel></app-tabel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import Filters from './Filters.vue'
import Tabel from './Tabel.vue'
import { FAMixin } from 'pevueglobal'

export default {
  mixins: [FAMixin],
  components: {
    appFilters: Filters,
    appTabel: Tabel,
  },
  data: function () {
    return {}
  },
  mounted() {
    if (!this.$route.query.legacy) {
      window.location = '/fe/public/agenda/' + this.$route.params.profgroup
    }

    this.getActiveProfGr()
    this.getActiveProfOrgid()
  },
  computed: {
    ...mapGetters('Agenda', ['loadMobileFilter', 'filterLoaded', 'totalCount']),
  },
  methods: {
    ...mapActions('Agenda', ['getActiveProfGr', 'getActiveProfOrgid', 'getLblReset']),
    ...mapMutations('Agenda', ['toggleFilter']),
    lblreset() {
      this.getLblReset()
    },
  },
}
</script>

<style scoped>
.btnfilter {
  width: 100%;
}
</style>
